import TaskForm, { TaskField } from "../TaskForm";
import ParcelService from "../../../services/parcelService";
import { TillageTask } from "../../../interfaces/TillageTask";

interface CreateEntryFormProps {
    onSave: (newEntry: TillageTask) => void;
    parcelId: number;
    cycleId: number;
    isNew: boolean;
    task?: TillageTask;
    readOnly?: boolean;
}

export default function TillageCreateForm(props: CreateEntryFormProps) {
    const parcelService = new ParcelService();

    const fields: TaskField[] = [
        { name: "note", label: "Beschreibung", type: "textarea", required: true },
        { name: "date", label: "Datum", type: "date", required: true }
    ] as const;

    const defaultState: TillageTask = {
        id: "",
        note: "",
        date: new Date()
    };

    return (
        <TaskForm<TillageTask>
            title="Bodenbearbeitung"
            fields={fields}
            isNew={props.isNew}
            task={props.task}
            defaultState={defaultState}
            onSubmit={async (data) => {
                if (props.isNew) {
                    await parcelService.createTillageTask(props.parcelId, props.cycleId, data);
                } else {
                    await parcelService.updateTillageTask(props.parcelId, props.cycleId, Number(data.id), data);
                }
                await props.onSave(data);
            }}
            readOnly={props.readOnly}
        />
    );
}
